import React from 'react';
import Presenter from './Presenter';

const Container: React.FC = () => {
  return <Presenter />;
};

export default Container;
